import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./DatePickerCalendar.module.css";
import classNames from "classnames";

/**
 *
 * Calendar Component that chooses a date for a new or edited meeting item
 *
 */
export function TimePickerCalendar({ selectedDate, changeSelectedDate }) {
  let selectedDateArray = selectedDate.split(".");
  const todaysDate = new Date();
  const [currentMonth, setMonth] = useState(parseInt(selectedDateArray[0] - 1)); // current month the calendar is on
  const [currentMonthName, setMonthName] = useState("");
  const [currentYear, setYear] = useState(
    parseInt(`20${selectedDateArray[2]}`)
  );
  const [days, setDays] = useState([]);
  const [selectedDateLocal, setSelectedDateLocal] = useState(
    new Date(selectedDate.split(".")).toLocaleDateString()
  );
  useEffect(() => {
    setDays(getDays(currentMonth + 1, currentYear));
    const dString = currentMonth + 1 + "/1/" + currentYear;
    const date = new Date(dString);
    setMonthName(date.toLocaleString("default", { month: "long" }));
  }, [currentMonth, currentYear]);

  const daysOfTheWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  function incrementMonth() {
    var nextMonthDate = new Date(currentMonth + 1 + "/01/" + currentYear);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    setMonth(nextMonthDate.getMonth());
    setYear(nextMonthDate.getFullYear());
  }
  function decrementMonth() {
    var lastMonthDate = new Date(currentMonth + 1 + "/01/" + currentYear);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    setMonth(lastMonthDate.getMonth());
    setYear(lastMonthDate.getFullYear());
  }

  function datesAreTheSame(date1, date2) {
    return (
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  // function dayHasEvent(date) {
  //   for (var i = 0; i < events.length; i++) {
  //     if (datesAreTheSame(date, new Date(events[i].date))) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  function getDays(month, year) {
    var currentDate = new Date(month + "/01/" + year);
    if (currentDate.getDay() !== 1) {
      while (currentDate.getDay() !== 1) {
        // making sure we start on a monday
        currentDate.setDate(currentDate.getDate() - 1);
      }
    }
    var d = [];
    for (var i = 0; i < 42; i++) {
      d.push({
        day: currentDate.getDate(),
        month: currentDate.getMonth(),
        year: currentDate.getFullYear(),
        dateString: currentDate.toLocaleDateString(),
        grayedOut: currentDate.getMonth() !== month - 1,
        today: datesAreTheSame(currentDate, todaysDate),
        // event: dayHasEvent(currentDate),
      });
      currentDate.setDate(currentDate.getDate() + 1); // increment date, using setDate() will properly account for month lengths
    }
    return d;
  }

  return (
    <div className={styles.container}>
      <div className={styles.monthAndYear}>
        {currentMonthName} {currentYear}
      </div>
      <div
        className={classNames(styles.button, styles.rightButton)}
        onClick={() => incrementMonth()}
      >
        <div className={styles.buttonText}>&gt;</div>
      </div>
      <div className={styles.button} onClick={() => decrementMonth()}>
        <div className={styles.buttonText}>&lt;</div>
      </div>

      <div className={styles.grid}>
        {daysOfTheWeek.map((item, index) => (
          <div key={index} className={styles.gridItem}>
            <div className={styles.weekDayText}>{item}</div>
          </div>
        ))}

        {days.map((item, index) => (
          <div
            onClick={() => {
              setSelectedDateLocal(item.dateString);
              changeSelectedDate(item.dateString);
            }}
            key={index}
            className={classNames(
              styles.gridItem,
              styles.pointer,
              item.grayedOut && styles.grayedOut,
              selectedDateLocal === item.dateString && styles.selectedDay
            )}
          >
            <div className={classNames(styles.dayText)}>{item.day}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

TimePickerCalendar.propTypes = {
  selectedDate: PropTypes.string,
  changeSelectedDate: PropTypes.func,
};
